import { cn } from '@/lib/cn';
import { inicialesDe } from '@/lib/negocio';

/** El sello del negocio: sus iniciales en un cuadro de esquinas redondas. Se lee con el nombre entero. */
export function Sello({ nombre, grande = false }: { nombre: string; grande?: boolean }) {
  return (
    <span
      role="img"
      aria-label={nombre}
      className={cn(
        'grid shrink-0 place-items-center bg-brand-700 font-bold tracking-wide text-white',
        grande ? 'h-14 w-14 rounded-2xl text-lg' : 'h-9 w-9 rounded-xl text-xs',
      )}
    >
      {inicialesDe(nombre)}
    </span>
  );
}
